import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from 'react-query';

import { code } from '@api/axiosAPI';

const TestListTemplate = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);

  const { isLoading, data: listData } = code.getComCdList(['getComCdList', count], { enabled: true, cacheTime: Infinity, staleTime: Infinity });

  if (isLoading) return <div>loading..</div>;

  return (
    <>
      <button type="button" onClick={() => setCount(count + 1)}>
        {count}
      </button>
      <br />
      <button type="button" onClick={() => navigate('/')}>
        {' '}
        home..
      </button>
      <br />
      <button type="button" onClick={() => queryClient.invalidateQueries(['getComCdList'])}>
        {' '}
        invalidate
      </button>
      <div>----------</div>
      {listData?.map((e) => {
        return (
          <div key={`${e.comCd}_${e.lngeCd}`} role="presentation" onClick={() => navigate(`${e.parComCd}`)}>
            {e.comCd} : {e.comCdNm}{' '}
          </div>
        );
      })}
    </>
  );
};

export default TestListTemplate;
